import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './statuses.reducer';
import { IStatuses } from 'app/shared/model/statuses.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IStatusesProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const Statuses = (props: IStatusesProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { statusesList, match, loading } = props;
  return (
    <div>
      <h2 id="statuses-heading">
        Statuses
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp; Create new Statuses
        </Link>
      </h2>
      <div className="table-responsive">
        {statusesList && statusesList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Status Value</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {statusesList.map((statuses, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${statuses.id}`} color="link" size="sm">
                      {statuses.id}
                    </Button>
                  </td>
                  <td>{statuses.statusValue}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${statuses.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${statuses.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${statuses.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Statuses found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ statuses }: IRootState) => ({
  statusesList: statuses.entities,
  loading: statuses.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Statuses);
